import React from 'react';

import {FloatingInteraction} from 'ui-library/floating-ui/FloatingConstants';
import Popover, {PopoverProps} from 'ui-library/floating-ui/Popover';
import BenchlingIcon, {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';
import {ElementMouseEvent} from 'util/Types';

export type PopoverIconProps = Omit<PopoverProps, 'children' | 'interaction'> & {
  /** @default FloatingInteraction.HOVER */
  interaction?: FloatingInteraction.HOVER | FloatingInteraction.CLICK;
  icon: BenchlingIconName;
  className?: string;
  onClick?: (e: ElementMouseEvent) => void;
};

/**
 * PopoverIcon is convenience component which uses an icon as the toggle element for a Popover
 * interaction.
 */
export default function PopoverIcon({
  className,
  icon,
  interaction,
  placement,
  renderContent,
  title,
  onClick,
}: PopoverIconProps): JSX.Element {
  return (
    <Popover
      renderContent={renderContent}
      placement={placement}
      title={title}
      interaction={interaction}
      disableContentSelection={onClick != null}
    >
      <BenchlingIcon icon={icon} className={className} onClick={onClick} />
    </Popover>
  );
}
